"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
require("quill/dist/quill.snow.css");
var _partlist = require("../../api/partlist.js");
var _dictionary = require("../../api/dictionary.js");
var _upload = require("../../api/upload.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      formLabelWidth: "120px",
      editorOption: {},
      state: "",
      timeout: null,
      isDisable: false,
      form: {
        buyDescriptionCn: "",
        buyDescriptionEn: "",
        buyDescriptionJa: "",
        contentMobileCn: "",
        contentMobileEn: "",
        contentMobileJa: "",
        contentPcCn: "",
        contentPcEn: "",
        contentPcJa: "",
        descriptionCn: "",
        descriptionEn: "",
        descriptionJa: "",
        line: "2",
        seq: "",
        serialNumber: "",
        type: "",
        seoTitleCn: "",
        seoTitleEn: "",
        seoTitleJa: "",
        seoKeywordCn: "",
        seoKeywordEn: "",
        seoKeywordJa: "",
        seoDescriptionCn: "",
        seoDescriptionEn: "",
        seoDescriptionJa: ""
      },
      multiple: true,
      uploadUrl: "".concat(process.env.VUE_APP_BASE_API, "cms/picture/upload"),
      uplaod_data: {
        "x-access-token": window.localStorage.getItem("token")
      },
      addRules: {
        serialNumber: [{
          required: true,
          trigger: "change"
        }],
        type: [{
          required: true,
          trigger: "change"
        }]
      },
      options: [{
        name: "上线",
        type: "0"
      }, {
        name: "下线",
        type: "1"
      }],
      type: [{
        name: "笔",
        type: "0"
      }, {
        name: "笔芯",
        type: "1"
      }, {
        name: "封套",
        type: "2"
      }],
      id: "",
      fileList: [],
      fileListEn: [],
      fileListJa: [],
      fileListMen: [],
      fileListMcn: [],
      fileListMja: [],
      fileLists: [],
      fileListsEn: [],
      fileListsJa: [],
      fileListsMen: [],
      fileListsMcn: [],
      fileListsMja: [],
      dialogVisible: false,
      fileupload: "",
      dialogImageUrl: "",
      dialogVisibleEn: false,
      fileuploadEn: "",
      dialogImageUrlEn: "",
      dialogVisibleJa: false,
      fileuploadJa: "",
      dialogImageUrlJa: "",
      dialogVisibleMen: false,
      fileuploadMen: "",
      dialogImageUrlMen: "",
      dialogVisibleMcn: false,
      fileuploadMcn: "",
      dialogImageUrlMcn: "",
      dialogVisibleMja: false,
      fileuploadMja: "",
      dialogImageUrlMja: "",
      url: '',
      urlen: '',
      urlja: '',
      urlMcn: '',
      urlMen: '',
      urlMja: '',
      list: [],
      recommend: [],
      lists: []
    };
  },
  created: function created() {
    this.loadAll();
  },
  mounted: function mounted() {
    var _this = this;
    this.id = this.$route.query.id;
    (0, _partlist.searchSeq)(this.id).then(function (res) {
      // const arr = res.voT.recommendId.split(',')
      _this.form = res.voT;
      _this.form.serialNumber = res.voT.serialNumber + "_" + res.voT.nameCn;
      _this.fileList = res.voT.contentPcCn.map(function (v) {
        _this.url = v.split('===')[0];
        return {
          name: "",
          url: _this.url,
          href: v
        };
      });
      _this.fileListEn = res.voT.contentPcEn.map(function (v) {
        _this.urlen = v.split('===')[0];
        return {
          name: "",
          url: _this.urlen,
          href: v
        };
      });
      _this.fileListJa = res.voT.contentPcJa.map(function (v) {
        _this.urlja = v.split('===')[0];
        return {
          name: "",
          url: _this.urlja,
          href: v
        };
      });
      _this.fileListMcn = res.voT.contentMobileCn.map(function (v) {
        _this.urlMcn = v.split('===')[0];
        return {
          name: "",
          url: _this.urlMcn,
          href: v
        };
      });
      _this.fileListMen = res.voT.contentMobileEn.map(function (v) {
        _this.urlMen = v.split('===')[0];
        return {
          name: "",
          url: _this.urlMen,
          href: v
        };
      });
      _this.fileListMja = res.voT.contentMobileJa.map(function (v) {
        _this.urlMja = v.split('===')[0];
        return {
          name: "",
          url: _this.urlMja,
          href: v
        };
      });
    });
  },
  methods: {
    //模糊搜索
    querySearch: function querySearch(queryString, cb) {
      this.loadAll();
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {
      this.form.serialNumber = item.value;
    },
    // handleUploadSuccess(res, file,fileList) {
    //   this.list.push(res.voT.downloadUrl);
    // },
    //  handleUploadsSuccess(res, file,fileList) {
    //   this.lists.push(res.voT.downloadUrl);
    // },
    // handleRemove (file,fileList){
    //     let arr = []
    //     this.form.mutiUrl.map(item=>{
    //       if(item.url !== file.url) {
    //           arr.push(item)
    //       }
    //     })
    //     this.form.mutiUrl = arr
    // },
    // handlesRemove(file,fileList){
    //     let str = []
    //     this.form.recommendUrl.map(item=>{
    //       if(item.url !== file.url) {
    //           str.push(item)
    //       }
    //     })
    //     this.form.recommendUrl = str
    // },
    loadAll: function loadAll() {
      var _this2 = this;
      var newList = [];
      (0, _dictionary.searchDiclist)({
        name: "",
        pageNo: 1,
        pageSize: 500,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        if (res.success) {
          res.voList.map(function (partItem) {
            if (partItem.name == "PART_SERIES") {
              newList.push(partItem);
              return newList;
            }
          });
          _this2.restaurants = newList;
        } else {
          _this2.restaurants = [];
        }
      });
    },
    //弹框封装
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    },
    handleUploadSuccess: function handleUploadSuccess(res, file, fileList) {
      this.fileList = fileList;
      //this.fileLists.push(res.voT.downloadUrl);
    },
    handleRemoves: function handleRemoves(file, fileList) {
      var _this3 = this;
      var mutiUrls = [];
      this.fileList = fileList;
      this.fileList.map(function (res) {
        mutiUrls.push(res.response.voT.downloadUrl);
        _this3.form.contentPcCn = mutiUrls.join(",");
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      var str = [];
      this.fileList.map(function (item) {
        if (item.url !== file.url) {
          str.push(item);
        }
      });
      this.fileList = str;
    },
    changePicture: function changePicture(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
      this.fileupload = this.fileList.findIndex(function (v) {
        return v.uid === file.uid;
      });
    },
    uploadSuccess: function uploadSuccess(res, file) {
      file.url = res.voT.downloadUrl.split('===')[0];
      file.href = res.voT.downloadUrl;
      this.fileList.splice(this.fileupload, 1, file);
      console.log(file.href, '909090');
      this.dialogImageUrl = file.url;
      this.dialogVisible = false;
    },
    close: function close() {
      this.dialogVisible = false;
    },
    //pc内容en
    handleUploadSuccessEn: function handleUploadSuccessEn(res, file, fileList) {
      this.fileListEn = fileList;
      //this.fileListsEn.push(res.voT.downloadUrl);
    },
    handleRemovesEn: function handleRemovesEn(file, fileList) {
      var _this4 = this;
      var mutiUrls = [];
      this.fileListEn = fileList;
      this.fileListEn.map(function (res) {
        mutiUrls.push(res.response.voT.downloadUrl);
        _this4.form.contentPcEn = mutiUrls.join(",");
      });
    },
    handleRemoveEn: function handleRemoveEn(file, fileList) {
      var str = [];
      this.fileListEn.map(function (item) {
        if (item.url !== file.url) {
          str.push(item);
        }
      });
      this.fileListEn = str;
    },
    changePictureEn: function changePictureEn(file) {
      this.dialogVisibleEn = true;
      this.dialogImageUrlEn = file.url;
      this.fileuploadEn = this.fileListEn.findIndex(function (v) {
        return v.uid === file.uid;
      });
    },
    uploadSuccessEn: function uploadSuccessEn(res, file) {
      file.url = res.voT.downloadUrl.split('===')[0];
      file.href = res.voT.downloadUrl;
      this.fileListEn.splice(this.fileuploadEn, 1, file);
      this.dialogImageUrlEn = file.url;
      this.dialogVisibleEn = false;
    },
    closeEn: function closeEn() {
      this.dialogVisibleEn = false;
    },
    //pc内容ja
    handleUploadSuccessJa: function handleUploadSuccessJa(res, file, fileList) {
      this.fileListJa = fileList;
      //this.fileListsJa.push(res.voT.downloadUrl);
    },
    handleRemovesJa: function handleRemovesJa(file, fileList) {
      var _this5 = this;
      var mutiUrls = [];
      this.fileListJa = fileList;
      this.fileListJa.map(function (res) {
        mutiUrls.push(res.response.voT.downloadUrl);
        _this5.form.contentPcJa = mutiUrls.join(",");
      });
    },
    handleRemoveJa: function handleRemoveJa(file, fileList) {
      var str = [];
      this.fileListJa.map(function (item) {
        if (item.url !== file.url) {
          str.push(item);
        }
      });
      this.fileListJa = str;
    },
    changePictureJa: function changePictureJa(file) {
      this.dialogVisibleJa = true;
      this.dialogImageUrlJa = file.url;
      this.fileuploadJa = this.fileListJa.findIndex(function (v) {
        return v.uid === file.uid;
      });
    },
    uploadSuccessJa: function uploadSuccessJa(res, file) {
      file.url = res.voT.downloadUrl.split('===')[0];
      file.href = res.voT.downloadUrl;
      this.fileListJa.splice(this.fileuploadJa, 1, file);
      this.dialogImageUrlJa = file.url;
      this.dialogVisibleJa = false;
    },
    closeJa: function closeJa() {
      this.dialogVisibleJa = false;
    },
    //移动端内容cn
    handleUploadSuccessMcn: function handleUploadSuccessMcn(res, file, fileList) {
      this.fileListMcn = fileList;
      //this.fileListsMcn.push(res.voT.downloadUrl);
    },
    handleRemovesMcn: function handleRemovesMcn(file, fileList) {
      var _this6 = this;
      var mutiUrls = [];
      this.fileListMcn = fileList;
      this.fileListMcn.map(function (res) {
        mutiUrls.push(res.response.voT.downloadUrl);
        _this6.form.contentMobileCn = mutiUrls.join(",");
      });
    },
    handleRemoveMcn: function handleRemoveMcn(file, fileList) {
      var str = [];
      this.fileListMcn.map(function (item) {
        if (item.url !== file.url) {
          str.push(item);
        }
      });
      this.fileListMcn = str;
    },
    changePictureMcn: function changePictureMcn(file) {
      this.dialogVisibleMcn = true;
      this.dialogImageUrlMcn = file.url;
      this.fileuploadMcn = this.fileListMcn.findIndex(function (v) {
        return v.uid === file.uid;
      });
    },
    uploadSuccessMcn: function uploadSuccessMcn(res, file) {
      file.url = res.voT.downloadUrl.split('===')[0];
      file.href = res.voT.downloadUrl;
      this.fileListMcn.splice(this.fileuploadMen, 1, file);
      this.dialogImageUrlMcn = file.url;
      this.dialogVisibleMcn = false;
    },
    closeMcn: function closeMcn() {
      this.dialogVisibleMcn = false;
    },
    //移动端内容en
    handleUploadSuccessMen: function handleUploadSuccessMen(res, file, fileList) {
      this.fileListMen = fileList;
      //this.fileListsMen.push(res.voT.downloadUrl);
    },
    handleRemovesMen: function handleRemovesMen(file, fileList) {
      var _this7 = this;
      var mutiUrls = [];
      this.fileListMen = fileList;
      this.fileListMen.map(function (res) {
        mutiUrls.push(res.response.voT.downloadUrl);
        _this7.form.contentMobileEn = mutiUrls.join(",");
      });
    },
    handleRemoveMen: function handleRemoveMen(file, fileList) {
      var str = [];
      this.fileListMen.map(function (item) {
        if (item.url !== file.url) {
          str.push(item);
        }
      });
      this.fileListEn = str;
    },
    changePictureMen: function changePictureMen(file) {
      this.dialogVisibleMen = true;
      this.dialogImageUrlMen = file.url;
      this.fileuploadMen = this.fileListMen.findIndex(function (v) {
        return v.uid === file.uid;
      });
    },
    uploadSuccessMen: function uploadSuccessMen(res, file) {
      file.url = res.voT.downloadUrl.split('===')[0];
      file.href = res.voT.downloadUrl;
      this.fileListMen.splice(this.fileuploadMen, 1, file);
      this.dialogImageUrlMen = file.url;
      this.dialogVisibleMen = false;
    },
    closeMen: function closeMen() {
      this.dialogVisibleMen = false;
    },
    //移动端内容ja
    handleUploadSuccessMja: function handleUploadSuccessMja(res, file, fileList) {
      this.fileListMja = fileList;
      //this.fileListsMja.push(res.voT.downloadUrl);
    },
    handleRemovesMja: function handleRemovesMja(file, fileList) {
      var _this8 = this;
      var mutiUrls = [];
      this.fileListMja = fileList;
      this.fileListMja.map(function (res) {
        mutiUrls.push(res.response.voT.downloadUrl);
        _this8.form.contentMobileJa = mutiUrls.join(",");
      });
    },
    handleRemoveMja: function handleRemoveMja(file, fileList) {
      var str = [];
      this.fileListMja.map(function (item) {
        if (item.url !== file.url) {
          str.push(item);
        }
      });
      this.fileListMja = str;
    },
    changePictureMja: function changePictureMja(file) {
      this.dialogVisibleMja = true;
      this.dialogImageUrlMja = file.url;
      this.fileuploadMja = this.fileListMja.findIndex(function (v) {
        return v.uid === file.uid;
      });
    },
    uploadSuccessMja: function uploadSuccessMja(res, file) {
      file.url = res.voT.downloadUrl.split('===')[0];
      file.href = res.voT.downloadUrl;
      this.fileListMja.splice(this.fileuploadMen, 1, file);
      this.dialogImageUrlMja = file.url;
      this.dialogVisibleMja = false;
    },
    closeMja: function closeMja() {
      this.dialogVisibleMja = false;
    },
    submit: function submit() {
      var _this9 = this;
      if (this.fileList == [] && this.form.contentPcCn == "") {
        this.msgTip("warning", "请上传PC内容CN");
        return false;
      } else if (this.fileListEn == [] && this.form.contentPcEn == "") {
        this.msgTip("warning", "请上传PC内容EN");
        return false;
      } else if (this.fileListJa == [] && this.form.contentPcJa == "") {
        this.msgTip("warning", "请上传PC内容JA");
        return false;
      } else if (this.fileListMcn == [] && this.form.contentMobileCn == "") {
        this.msgTip("warning", "请上传移动端内容CN");
        return false;
      } else if (this.fileListMen == [] && this.form.contentMobileEn == "") {
        this.msgTip("warning", "请上传移动端内容EN");
        return false;
      } else if (this.fileListMja == [] && this.form.contentMobileJa == "") {
        this.msgTip("warning", "请上传移动端内容JA");
        return false;
      } else {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            // 表单验证通过之后的操作
            _this9.isDisable = false;
            var str = [];
            _this9.fileList.map(function (item) {
              if (item.response) {
                str.push(item.response.voT.downloadUrl);
              } else {
                str.push(item.href);
              }
            });
            // if(this.fileLists.length > 0){
            //   this.fileLists.map(item => {
            //     str.push(item);
            //   });
            // }
            _this9.form.contentPcCn = str.toString();
            var arr = [];
            _this9.fileListEn.map(function (item) {
              if (item.response) {
                arr.push(item.response.voT.downloadUrl);
              } else {
                arr.push(item.href);
              }
            });
            _this9.form.contentPcEn = arr.toString();
            var arrJa = [];
            _this9.fileListJa.map(function (item) {
              if (item.response) {
                arrJa.push(item.response.voT.downloadUrl);
              } else {
                arrJa.push(item.href);
              }
            });
            _this9.form.contentPcJa = arrJa.toString();
            var arrMcn = [];
            _this9.fileListMcn.map(function (item) {
              if (item.response) {
                arrMcn.push(item.response.voT.downloadUrl);
              } else {
                arrMcn.push(item.href);
              }
            });
            _this9.form.contentMobileCn = arrMcn.toString();
            var arrMen = [];
            _this9.fileListMen.map(function (item) {
              if (item.response) {
                arrMen.push(item.response.voT.downloadUrl);
              } else {
                arrMen.push(item.href);
              }
            });
            _this9.form.contentMobileEn = arrMen.toString();
            var arrMja = [];
            _this9.fileListMja.map(function (item) {
              if (item.response) {
                arrMja.push(item.response.voT.downloadUrl);
              } else {
                arrMja.push(item.href);
              }
            });
            _this9.form.contentMobileJa = arrMja.toString();
            _this9.form.serialNumber = _this9.form.serialNumber.split("_")[0];
            // this.form.recommendId = this.form.recommendId.toString()
            (0, _partlist.changePart)(_this9.id, _this9.form).then(function (res) {
              if (res.success) {
                _this9.msgTip("success", "修改成功");
                _this9.$store.dispatch("tagsView/delView", _this9.$route).then(function () {
                  _this9.$nextTick(function () {
                    _this9.$router.replace({
                      path: "/parts/list",
                      query: {
                        cur: _this9.$route.query.cur,
                        serialNumber: _this9.$route.query.serialNumber,
                        line: _this9.$route.query.line,
                        type: _this9.$route.query.type
                      }
                    });
                  });
                });
              } else {
                // this.form.recommendId = []
                // this.form.mutiUrl = this.form.mutiUrl.split(',')
                // this.form.recommendUrl = this.form.recommendUrl.split(',')
                _this9.msgTip("error", res.errorMsg);
                _this9.isDisable = false;
              }
            });
          } else {
            _this9.msgTip("warning", "请填写完整");
            return false;
          }
        });
      }
    }
  }
};